import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerAllCardComponents } from './lib/cardSetup';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './main.css';

registerAllCardComponents();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container missing');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
